angular.module('NumbersEditor').directive('numbersTimePicker', ['dateFilter', function (dateFilter) {
    return {
        restrict: 'E',
        replace: 'true',
        template: '<div data-ng-class="cssClass">' +
                        '<input ng-required="true" type="text" class="form-control" ng-model="timeHours" placeholder="00" typeahead-editable="false" typeahead="hour for hour in hours | filter:$viewValue | limitTo:8">' +
                        '<span class="input-group-addon">:</span>' +
                        '<input ng-required="true" type="text" class="form-control" ng-model="timeminutes" placeholder="00" typeahead-editable="false" typeahead="minute for minute in minutes | filter:$viewValue | limitTo:8">' +
                        '<span class="input-group-addon">:00</span>' +
                   '</div>',
        scope: {
            eventTime: '=?',
        },
        link: function (scope) {
            if (scope.eventTime == undefined) scope.eventTime = new Date(1970, 00, 01);
            var hh = dateFilter(scope.eventTime, "HH");
            var mm = dateFilter(scope.eventTime, "mm");
            scope.timeHours = hh == "00" ? '' : hh;
            scope.timeminutes = mm == "00" ? '' : mm;
            scope.cssClass = "input-group input-group-sm timepicker-sm";

            scope.hours = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'];
            scope.minutes = ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19',
                           '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '32', '33', '34', '35', '36', '37', '38', '39',
                           '40', '41', '42', '43', '44', '45', '46', '47', '48', '49', '50', '51', '52', '53', '54', '55', '56', '57', '58', '59'];

            scope.$watch('timeHours', function () {
                if (scope.timeHours != undefined) {
                    scope.eventTime = new Date(1970, 00, 01, scope.timeHours, scope.timeminutes).getTime();
                    scope.cssClass = "input-group input-group-sm timepicker-sm";
                } else {
                    scope.cssClass = "input-group input-group-sm timepicker-sm has-error";
                }
            });

            scope.$watch('timeminutes', function () {
                if (scope.timeminutes != undefined) {
                    scope.eventTime = new Date(1970, 00, 01, scope.timeHours, scope.timeminutes).getTime();
                    scope.cssClass = "input-group input-group-sm timepicker-sm";
                } else {
                    scope.cssClass = "input-group input-group-sm timepicker-sm has-error";
                }
            });
        }
    };
}]);